import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore"; // ✅ Import Firestore

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyA0G3UOvQl5N5JgMLKecnl9_F2oumSFlBw",
  authDomain: "inside-man-75900.firebaseapp.com",
  projectId: "inside-man-75900",
  storageBucket: "inside-man-75900.firebasestorage.app",
  messagingSenderId: "651146547118",
  appId: "1:651146547118:web:35992b95e690489c54c23f",
  measurementId: "G-7J6TL6XL0L"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app); // ✅ Initialize Firestore

export { auth, db };
export default app;
